const lookbookConfig = {
    lookbook: {
        filterLayout: 'LookbookFilterDefaultLayout',
        listLayout: 'LookbookListDefaultLayout',
        paginationLayout: 'PaginationDefaultLayout',
        getFunc: 'getLookbook',
        getChannelFunc: 'getLookbookChannel',
        isChannel: true,
        pageRow: 10,
        paginationType: 'pagination',
        listApiParamSet: {
            ip: 1,
            file: 1,
            channel: 1,
            save: 1,
            item: 1,
            hash: 1,
        },
        sortOptions: {},
        startSort: {},
        deleteFunc: 'deleteLookbook',
        deleteApiParamsSet: {},
        deleteSuccessType: 1,
        deleteFailTypes: {},
        keyName: 'l_idx'
    },
    createLookbook: {
        getFunc: '',
        detailApiParamSet: {},
        isChannel: true,
        writeFunc:'createLookbook',
        getChannelFunc: 'getLookbookChannel',
        writeLayouts: ['LookbookWriteDefaultLayout'],
        writeApiParamSet: {},
        parsingData: {
            display: 'l_display',
            url: 'l_url',
            title: 'l_title',
            channelKey: 'lc_idx',
            hashtag:'hashtag',
            content: 'l_content',
        },
        fileInfo: [],
        directUrl: '',
        directType: 'back',
        writeSuccessType: 1,
        writeFailTypes: {
            '-2': '권한없음',
            '-100': '필수값이 존재하지 않습니다.',
            '-811': '채널이 존재하지 않습니다.',
            '-819':'URL이 중복되었습니다.',
        },
        writeFailMsg: '게시글을 등록할 수 없습니다.',
        fileUploadFailMsg: '파일 등록에 실패하였습니다.',
        deleteFunc: 'deleteLookbook',
        deleteApiParamsSet: {},
        deleteSuccessType: 1,
        deleteFailTypes: {},
        keyName: 'l_idx',
    },
    updateLookbook: {
        getFunc: 'getLookbookDetail',
        detailApiParamSet: {
            ip:0,
            file: 1,
            channel: 1,
            save: 1,
            item: 1,
            hash: 1,},
        isChannel: true,
        writeFunc:'updateLookbook',
        getChannelFunc: 'getLookbookChannel',
        writeLayouts: ['LookbookWriteDefaultLayout'],
        writeApiParamSet: {},
        parsingData: {
            display: 'l_display',
            url: 'l_url',
            title: 'l_title',
            channelKey: 'lc_idx',
            hashtag:'hashtag',
            content: 'l_content',
        },
        fileInfo: [
        ],
        directUrl: '',
        directType: 'back',
        writeSuccessType: 1,
        writeFailTypes: {
            '-2': '권한없음',
            '-100': '필수값이 존재하지 않습니다.',
            '-811': '채널이 존재하지 않습니다.',
            '-819':'URL이 중복되었습니다.',
        },
        writeFailMsg: '게시글을 등록할 수 없습니다.',
        fileUploadFailMsg: '파일 등록에 실패하였습니다.',
        deleteFunc: 'deleteLookbook',
        deleteApiParamsSet: {},
        deleteSuccessType: 1,
        deleteFailTypes: {},
        keyName: 'l_idx',
    },
    hash: {
        filterLayout: 'LookbookFilterCreatedLayout',
        listLayout: 'LookbookListHashLayout',
        paginationLayout: 'PaginationDefaultLayout',
        getFunc: 'getHash',
        getCategoryFunc: '',
        isCategory: false,
        pageRow: 10,
        paginationType: 'pagination',
        listApiParamSet: {
            ip: 1,
            cnt: 1,
        },
        sortOptions: {},
        startSort: {},
        deleteFunc: 'deleteHash',
        deleteApiParamsSet: {},
        deleteSuccessType: 1,
        deleteFailTypes: {
            '-888': "사용중인 플레이옷이 존재합니다."
        },
        keyName: 'lh_idx'
    },
    hashCreate: {
        getFunc: '',
        detailApiParamSet: {},
        writeFunc: 'createHash',
        writeLayouts: ['LookbookWriteHashLayout'],
        writeApiParamSet: {},
        parsingData: {
            hashTitle: "lh_hash",
        },
        directUrl: '',
        directType: 'back',
        writeSuccessType: 1,
        fileInfo: [],
        writeFailTypes: {},
        writeFailMsg: '게시글을 등록할 수 없습니다.',
        fileUploadFailMsg: '파일 등록에 실패하였습니다.',
        deleteFunc: '',
        deleteApiParamsSet: {},
        deleteSuccessType: 1,
        deleteFailTypes: {},
        keyName: 'lh_idx',
    },
    hashUpdate: {
        getFunc: 'getHash',
        detailApiParamSet: {ip: 0},
        writeFunc: 'updateHash',
        writeLayouts: ['LookbookWriteHashLayout'],
        writeApiParamSet: {},
        parsingData: {
            hashTitle: "lh_hash",
        },
        fileInfo: [],
        allSetData: true,
        directUrl: '',
        directType: 'back',
        writeSuccessType: 1,
        writeFailTypes: {},
        writeFailMsg: '게시글을 등록할 수 없습니다.',
        fileUploadFailMsg: '파일 등록에 실패하였습니다.',
        deleteFunc: 'deleteHash',
        deleteApiParamsSet: {},
        deleteSuccessType: 1,
        deleteFailTypes: {},
        keyName: 'lh_idx',
    },
    theme: {
        filterLayout: 'LookbookFilterCreatedLayout',
        listLayout: 'LookbookListThemeLayout',
        paginationLayout: 'PaginationDefaultLayout',
        getFunc: 'getTheme',
        getCategoryFunc: '',
        isCategory: false,
        pageRow: 10,
        paginationType: 'pagination',
        listApiParamSet: {
            ip: 1,
            file: 1,//ThemeFile 노출 유무. 0:미노출(기본값), 1:노출
            hash: 1,//해시 노출 유무. 0:미노출, 1:노출(기본값)
            count: 1,
        },
        sortOptions: {},
        startSort: {},
        deleteFunc: 'deleteTheme',
        deleteApiParamsSet: {},
        deleteSuccessType: 1,
        deleteFailTypes: {
            '-': "권한이 없습니다.",
            '-3': "사용중인 매거진이 존재합니다.",
        },
        keyName: 'lt_idx'
    },
    themeCreate: {
        getFunc: '',
        detailApiParamSet: {},
        getCategoryFunc: '',
        isCategory: false,
        writeFunc: 'createTheme',
        writeLayouts: ['LookbookWriteThemeLayout'],
        writeApiParamSet: {},
        parsingData: {
            title: "lt_title",
            display: "lt_display",
            hashtag: 'hash',
        },
        allSetData: false,
        fileInfo: [
            {fileName: 'files', fileType: 'lbookThemeImg', required: true, validatorMsg: '메인이미지를 추가해주세요.',},
        ],
        directUrl: '',
        directType: 'back',
        writeSuccessType: 1,
        writeFailTypes: {},
        writeFailMsg: '등록할 수 없습니다.',
        fileUploadFailMsg: '파일 등록에 실패하였습니다.',
        deleteFunc: '',
        deleteApiParamsSet: {},
        deleteSuccessType: 1,
        deleteFailTypes: {},
        keyName: 'lt_idx',
    },
    themeUpdate: {
        getFunc: 'getTheme',
        detailApiParamSet: {
            file: 1,
            hash: 1,
            count: 1
        },
        getCategoryFunc: '',
        isCategory: false,
        writeFunc: 'updateTheme',
        writeLayouts: ['LookbookWriteThemeLayout'],
        writeApiParamSet: {},
        parsingData: {
            title: "lt_title",
            display: "lt_display",
            hashtag: 'hash',
        },
        allSetData: true,
        fileInfo: [
            {fileName: 'files', fileType: 'lbookThemeImg', required: true, validatorMsg: '메인이미지를 추가해주세요.',},
        ],
        directUrl: '',
        directType: '',
        writeSuccessType: 1,
        writeFailTypes: {},
        writeFailMsg: '등록할 수 없습니다.',
        fileUploadFailMsg: '파일 등록에 실패하였습니다.',
        deleteFunc: 'deleteTheme',
        deleteApiParamsSet: {},
        deleteSuccessType: 1,
        deleteFailTypes: {
        },
        keyName: 'lt_idx'
    },
    channel: {
        filterLayout: 'LookbookFilterCreatedLayout',
        listLayout: 'LookbookListChannelLayout',
        paginationLayout: 'PaginationDefaultLayout',
        getFunc: 'getChannel',
        getCategoryFunc: '',
        isCategory: false,
        pageRow: 10,
        paginationType: 'pagination',
        listApiParamSet: {
            ip: 1,
            cnt: 1,
            file: 1,
            save: 1,
        },
        sortOptions: {},
        startSort: {},
        deleteFunc: 'deleteChannel',
        deleteApiParamsSet: {},
        deleteSuccessType: 1,
        deleteFailTypes: {},
        keyName: 'lc_idx'
    },
    channelCreate: {
        getFunc: '',
        detailApiParamSet: {},
        writeFunc: 'createChannel',
        writeLayouts: ['LookbookWriteChannelLayout'],
        writeApiParamSet: {},
        parsingData: {
            title: "lc_title",
            channelInfo: 'lc_content',
            channelUrl: 'lc_url'
        },
        directUrl: '',
        directType: 'back',
        writeSuccessType: 1,
        fileInfo: [
            {
                fileName: 'files',
                fileType: 'channel',
                required: true,
                validatorMsg: '채널이미지를 추가해주세요.',
            },
        ],
        writeFailTypes: {
            '-1': '채널 등록에 실패하였습니다.',
            '-2': '채널 등록 권한이 없습니다.',
            '100': '채널 등록에 실패하였습니다.',
            '-100': '필수 항목들을 확인해주세요.',
            '-800':'채널명이 존재합니다.',
        },
        writeFailMsg: '채널 등록에 실패하였습니다.',
        fileUploadFailMsg: '파일 등록에 실패하였습니다.',
        deleteFunc: '',
        deleteApiParamsSet: {},
        deleteSuccessType: 1,
        deleteFailTypes: {},
        keyName: 'lc_idx',
    },
    channelUpdate: {
        getFunc: 'getChannel',
        detailApiParamSet: {
            cnt: 1,
            file: 1,
            save: 1,
        },
        isCategory: false,
        writeFunc: 'updateChannel',
        writeLayouts: ['LookbookWriteChannelLayout'],
        writeApiParamSet: {},
        parsingData: {
            title: "lc_title",
            channelInfo: 'lc_content',
            channelUrl: 'lc_url'
        },
        allSetData: true,
        fileInfo: [
            {
                fileName: 'files',
                fileType: 'channel',
                required: true,
                validatorMsg: '채널이미지를 추가해주세요.',
            },
        ],
        directUrl: '',
        directType: 'back',
        writeSuccessType: 1,
        writeFailTypes: {
            '-1': '채널 수정에 실패하였습니다.',
            '-2': '채널 수정 권한이 없습니다.',
            '100': '채널 수정에 실패하였습니다.',
            '-100': '필수 항목들을 확인해주세요.',
            '-800':'삭제된 채널로 수정에 실패하였습니다.',
        },
        writeFailMsg: '채널 수정에 실패하였습니다.',
        fileUploadFailMsg: '파일 등록에 실패하였습니다.',
        deleteFunc: 'deleteChannel',
        deleteApiParamsSet: {},
        deleteSuccessType: 1,
        deleteFailTypes: {},
        keyName: 'lc_idx'
    },
    recommendSelect: {
        filterLayout: 'LookbookFilterDefaultLayout',
        listLayout: 'LookbookListRecommendSelectLayout',
        paginationLayout: 'PaginationRecommendSelectLayout',
        getFunc: 'getLookbook',
        isChannel: true,
        getChannelFunc: 'getLookbookChannel',
        pageRow: 10,
        paginationType: 'pagination',
        listApiParamSet: {
            ip: 1,
            h: 1,
            sa: 1,
        },
        sortOptions: {},
        startSort: {},
        deleteFunc: 'deleteLookbook',
        deleteApiParamsSet: {},
        deleteSuccessType: 1,
        deleteFailTypes: {},
        keyName: 'l_idx'
    },
}

export default {
    methods: {
        returnLookbookConfig(type) {
            return lookbookConfig[type];
        },
    },
    filterConfig: {
        ti: { //제목
            type: 'query',
            classname: 'searchInput'
        },
        cr: { //작성일
            type: 'between',
            classname: 'filterDate'
        },
        di: { //노출여부
            type: 'match',
            classname: 'filterDisplay',
            option: {
                book: {
                    res: 1,
                }
            },
        },

        lcid: {
            type: 'match',
            classname: 'filterChannel'
        },
        lhid: { //해시태그
            type: 'terms',
            classname: 'filterHash'
        }
    },
}
